import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { CookieBanner } from '../components/CookieBanner';
import { useLanguage } from '../contexts/LanguageContext';
const termsContent = {
  sk: {
    title: 'Podmienky',
    titleHighlight: 'používania',
    lastUpdated: 'Posledná aktualizácia: 3. februára 2026',
    sections: [{
      title: '1. Súhlas s podmienkami',
      content: `Prístupom k službám Jetly Agency alebo ich používaním súhlasíte s tým, že budete viazaní týmito Podmienkami používania. Ak nesúhlasíte s akoukoľvek časťou týchto podmienok, nesmiete používať naše služby.`
    }, {
      title: '2. Popis služieb',
      content: `Jetly Agency poskytuje profesionálne služby návrhu a vývoja webstránok, vrátane:
- Vytvorenie bezplatného dema webstránky
- Vlastný návrh a vývoj webstránky
- Pomoc s nastavením hostingu webstránky
- 30 dní podpory po spustení`
    }, {
      title: '3. Ceny a platba',
      content: `**Bezplatné demo:** Poskytujeme bezplatné demo webstránky bez akýchkoľvek záväzkov. Platíte len vtedy, ak schválite návrh a chcete ho spustiť.
**Profesionálny balík (299 €):** Jednorazová platba za kompletnú webstránku. Platba sa vyžaduje po schválení dema pred konečným spustením.
**Hosting (10 €/mesiac):** Voliteľná služba hostingu a údržby.
Všetky ceny sú v eurách (EUR). Platby sú po začatí prác nevratné.`
    }, {
      title: '4. Časový harmonogram projektu',
      content: `Štandardné projekty sú dokončené do 24 hodín od schválenia dema. Časový harmonogram sa môže líšiť v závislosti od:
- Zložitosti projektu
- Času odozvy klienta na spätnú väzbu
- Dostupnosti obsahu`
    }, {
      title: '5. Revízie a zmeny',
      content: `Náš balík obsahuje 3 kolá revízií. Ďalšie revízie môžu byť spoplatnené. Zásadné zmeny rozsahu po schválení môžu vyžadovať dodatočné poplatky.`
    }, {
      title: '6. Duševné vlastníctvo',
      content: `Po úplnom zaplatení vlastníte všetky práva na konečný návrh a kód webstránky. Pred zaplatením zostáva všetka práca majetkom Jetly Agency.`
    }, {
      title: '7. Povinnosti klienta',
      content: `Klienti sú zodpovední za:
- Poskytnutie presného obsahu a materiálov
- Včasnú spätnú väzbu a schválenia
- Registráciu domény a hosting (ak nevyužívajú naše služby)
- Dodržiavanie platných zákonov`
    }, {
      title: '8. Obmedzenie zodpovednosti',
      content: `Jetly Agency nenesie zodpovednosť za nepriame, náhodné alebo následné škody vyplývajúce z používania našich služieb. Naša celková zodpovednosť je obmedzená na sumu zaplatenú za služby.`
    }, {
      title: '9. Ukončenie',
      content: `Ktorákoľvek strana môže zmluvu ukončiť písomným oznámením. Platby za dokončenú prácu sú nevratné.`
    }, {
      title: '10. Kontakt',
      content: `V prípade otázok týkajúcich sa týchto Podmienok nás kontaktujte na:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  },
  en: {
    title: 'Terms of',
    titleHighlight: 'Service',
    lastUpdated: 'Last updated: February 3, 2026',
    sections: [{
      title: '1. Agreement to Terms',
      content: `By accessing or using Jetly Agency's services, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not use our services.`
    }, {
      title: '2. Services Description',
      content: `Jetly Agency provides professional web design and development services, including:
- Free website demo creation
- Custom website design and development
- Website hosting setup assistance
- 30 days of post-launch support`
    }, {
      title: '3. Pricing and Payment',
      content: `**Free Demo:** We provide a free website demo with no obligation. You only pay if you approve the design and want to launch.
**Professional Package (€299):** One-time payment for complete website. Payment required after demo approval before final launch.
**Hosting (€10/month):** Optional hosting and maintenance service.
All prices are in Euros (EUR). Payments are non-refundable once work has commenced.`
    }, {
      title: '4. Project Timeline',
      content: `Standard projects are completed within 24 hours from demo approval. Timeline may vary based on:
- Project complexity
- Client feedback response time
- Content availability`
    }, {
      title: '5. Revisions and Changes',
      content: `Our package includes 3 rounds of revisions. Additional revisions may incur extra charges. Major scope changes after approval may require additional fees.`
    }, {
      title: '6. Intellectual Property',
      content: `Upon full payment, you own all rights to the final website design and code. Before payment, all work remains property of Jetly Agency.`
    }, {
      title: '7. Client Responsibilities',
      content: `Clients are responsible for:
- Providing accurate content and materials
- Timely feedback and approvals
- Domain registration and hosting (if not using our services)
- Compliance with applicable laws`
    }, {
      title: '8. Limitation of Liability',
      content: `Jetly Agency is not liable for indirect, incidental, or consequential damages arising from use of our services. Our total liability is limited to the amount paid for services.`
    }, {
      title: '9. Termination',
      content: `Either party may terminate the agreement with written notice. Payments for completed work are non-refundable.`
    }, {
      title: '10. Contact',
      content: `For questions about these Terms, contact us at:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  },
  ru: {
    title: 'Условия',
    titleHighlight: 'использования',
    lastUpdated: 'Последнее обновление: 3 февраля 2026',
    sections: [{
      title: '1. Согласие с условиями',
      content: `Используя услуги Jetly Agency, вы соглашаетесь с настоящими Условиями использования. Если вы не согласны с какой-либо частью этих условий, вы не можете использовать наши услуги.`
    }, {
      title: '2. Описание услуг',
      content: `Jetly Agency предоставляет профессиональные услуги по веб-дизайну и разработке, включая:
- Создание бесплатного демо сайта
- Индивидуальный дизайн и разработка сайта
- Помощь в настройке хостинга
- 30 дней поддержки после запуска`
    }, {
      title: '3. Цены и оплата',
      content: `**Бесплатное демо:** Мы предоставляем бесплатное демо сайта без обязательств. Вы платите только в том случае, если утверждаете дизайн и хотите его запустить.
**Профессиональный пакет (€299):** Единоразовый платеж за готовый сайт. Оплата требуется после утверждения демо перед финальным запуском.
**Хостинг (€10/мес):** Дополнительная услуга хостинга и обслуживания.
Все цены указаны в евро (EUR). Платежи не подлежат возврату после начала работ.`
    }, {
      title: '4. Сроки проекта',
      content: `Стандартные проекты выполняются в течение 24 часов после утверждения демо. Сроки могут варьироваться в зависимости от:
- Сложности проекта
- Времени ответа клиента
- Наличия контента`
    }, {
      title: '5. Правки и изменения',
      content: `Наш пакет включает 3 раунда правок. Дополнительные правки могут потребовать дополнительной оплаты. Значительные изменения после утверждения могут потребовать дополнительной оплаты.`
    }, {
      title: '6. Интеллектуальная собственность',
      content: `После полной оплаты вы получаете все права на финальный дизайн и код сайта. До оплаты вся работа остается собственностью Jetly Agency.`
    }, {
      title: '7. Обязанности клиента',
      content: `Клиенты несут ответственность за:
- Предоставление точного контента и материалов
- Своевременную обратную связь и утверждения
- Регистрацию домена и хостинг (если не используются наши услуги)
- Соблюдение применимых законов`
    }, {
      title: '8. Ограничение ответственности',
      content: `Jetly Agency не несет ответственности за косвенные, случайные или последующие убытки, возникающие в результате использования наших услуг. Наша общая ответственность ограничена суммой, уплаченной за услуги.`
    }, {
      title: '9. Расторжение',
      content: `Любая из сторон может расторгнуть соглашение с письменным уведомлением. Оплата за выполненную работу не возвращается.`
    }, {
      title: '10. Контакты',
      content: `По вопросам, связанным с настоящими Условиями, свяжитесь с нами:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  },
  ua: {
    title: 'Умови',
    titleHighlight: 'використання',
    lastUpdated: 'Останнє оновлення: 3 лютого 2026',
    sections: [{
      title: '1. Згода з умовами',
      content: `Використовуючи послуги Jetly Agency, ви погоджуєтеся з цими Умовами використання. Якщо ви не згодні з будь-якою частиною цих умов, ви не можете використовувати наші послуги.`
    }, {
      title: '2. Опис послуг',
      content: `Jetly Agency надає професійні послуги з веб-дизайну та розробки, включаючи:
- Створення безкоштовного демо сайту
- Індивідуальний дизайн та розробка сайту
- Допомога в налаштуванні хостингу
- 30 днів підтримки після запуску`
    }, {
      title: '3. Ціни та оплата',
      content: `**Безкоштовне демо:** Ми надаємо безкоштовне демо сайту без зобов'язань. Ви платите тільки в тому випадку, якщо затверджуєте дизайн і хочете його запустити.
**Професійний пакет (€299):** Одноразовий платіж за готовий сайт. Оплата потрібна після затвердження демо перед фінальним запуском.
**Хостинг (€10/міс):** Додаткова послуга хостингу та обслуговування.
Всі ціни вказані в євро (EUR). Платежі не підлягають поверненню після початку робіт.`
    }, {
      title: '4. Терміни проєкту',
      content: `Стандартні проєкти виконуються протягом 24 годин після затвердження демо. Терміни можуть змінюватися залежно від:
- Складності проєкту
- Часу відповіді клієнта
- Наявності контенту`
    }, {
      title: '5. Правки та зміни',
      content: `Наш пакет включає 3 раунди правок. Додаткові правки можуть вимагати додаткової оплати. Значні зміни після затвердження можуть вимагати додаткової оплати.`
    }, {
      title: '6. Інтелектуальна власність',
      content: `Після повної оплати ви отримуєте всі права на фінальний дизайн та код сайту. До оплати вся робота залишається власністю Jetly Agency.`
    }, {
      title: '7. Обов’язки клієнта',
      content: `Клієнти несуть відповідальність за:
- Надання точного контенту та матеріалів
- Своєчасний зворотний зв'язок та затвердження
- Реєстрацію домену та хостинг (якщо не використовуються наші послуги)
- Дотримання застосовних законів`
    }, {
      title: '8. Обмеження відповідальності',
      content: `Jetly Agency не несе відповідальності за непрямі, випадкові або подальші збитки, що виникають в результаті використання наших послуг. Наша загальна відповідальність обмежена сумою, сплаченою за послуги.`
    }, {
      title: '9. Розірвання',
      content: `Будь-яка із сторін може розірвати угоду з письмовим повідомленням. Оплата за виконану роботу не повертається.`
    }, {
      title: '10. Контакти',
      content: `З питань, пов'язаних з цими Умовами, зв'яжіться з нами:
Email: legal@jetly.agency
Telegram: @jetlyagency`
    }]
  }
};
export function TermsPage() {
  const {
    language
  } = useLanguage();
  const content = termsContent[language] || termsContent.en;
  const formatContent = (text: string) => {
    return text.split('\n').map((line, i) => {
      const formattedLine = line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
      if (line.startsWith('- ')) {
        return <li key={i} className="ml-4" dangerouslySetInnerHTML={{
          __html: formattedLine.substring(2)
        }} data-id="element-847" />;
      }
      if (line.trim() === '') {
        return <br key={i} data-id="element-848" />;
      }
      return <p key={i} className="mb-2" dangerouslySetInnerHTML={{
        __html: formattedLine
      }} data-id="element-849" />;
    });
  };
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-850">
      <Navigation data-id="element-851" />

      <div className="pt-32 pb-20 px-4" data-id="element-852">
        <div className="max-w-4xl mx-auto" data-id="element-853">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-854">
            <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{
            color: 'var(--text-primary)'
          }} data-id="element-855">
              {content.title}{' '}
              <span style={{
              color: 'var(--accent)'
            }} data-id="element-856">
                {content.titleHighlight}
              </span>
            </h1>
            <p className="text-sm mb-8" style={{
            color: 'var(--text-muted)'
          }} data-id="element-857">
              {content.lastUpdated}
            </p>

            <div className="space-y-8" data-id="element-858">
              {content.sections.map((section, index) => <Section key={index} title={section.title} data-id="element-859">
                  {formatContent(section.content)}
                </Section>)}
            </div>
          </motion.div>
        </div>
      </div>

      <Footer data-id="element-860" />
      <CookieBanner data-id="element-861" />
    </div>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div className="rounded-2xl border p-6 sm:p-8" style={{
    borderColor: 'var(--border)',
    backgroundColor: 'var(--bg-secondary)'
  }} data-id="element-862">
      <h2 className="text-xl sm:text-2xl font-bold mb-4" style={{
      color: 'var(--text-primary)'
    }} data-id="element-863">
        {title}
      </h2>
      <div className="space-y-3 text-sm sm:text-base [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:space-y-2" style={{
      color: 'var(--text-secondary)'
    }} data-id="element-864">
        {children}
      </div>
    </div>;
}